var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvassingMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.004,
    height: 89.004,
    viewBox: "0 0 89.004 89.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-map",
    x1: 0.506,
    y1: 0.936,
    x2: 0.072,
    y2: 0.524,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eef9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00de92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-map-2",
    x1: 0.371,
    y1: -0.087,
    x2: 1.07,
    y2: 0.634,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7dff94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-map-3",
    x1: 0.169,
    y1: 0.816,
    x2: 0.936,
    y2: 0.083,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8fcc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#aff8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#86e8ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#6ddd9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64da98"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    transform: "translate(-90.412 -390.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M90.412,399.935V470.9a9.019,9.019,0,0,0,9.019,9.019H170.4a8.993,8.993,0,0,0,6.378-2.641L93.054,393.557A8.992,8.992,0,0,0,90.412,399.935Z",
    fill: "url(#linear-gradient-map)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M179.416,399.935a9.019,9.019,0,0,0-9.019-9.02H99.431a8.991,8.991,0,0,0-6.377,2.642l83.721,83.721a8.991,8.991,0,0,0,2.641-6.378Z",
    fill: "url(#linear-gradient-map-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M146.615,424.266a11.7,11.7,0,1,1-11.7-11.7,11.713,11.713,0,0,1,11.7,11.7Zm-36.438,0c0,11.975,17.475,37.281,20.978,42.233l3.2,4.514a.693.693,0,0,0,1.132,0l3.192-4.514c3.5-4.952,20.977-30.258,20.977-42.233a24.737,24.737,0,1,0-49.474,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 11.693,
    cy: 11.693,
    r: 11.693,
    transform: "translate(123.222 412.562)",
    fill: "url(#linear-gradient-map-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvassingMap);
export default __webpack_public_path__ + "static/media/CanvassingMap.79bb8ae86b92a287ec675af42383f57f.svg";
export { ForwardRef as ReactComponent };